/* eslint-disable import/prefer-default-export */
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';
